<template>
  <vueper-slides v-if="items.length"
                 ref="slider"
                 class="no-shadow"
                 :class="arrowsOutside ? 'arrows-padding' : ''"
                 fixed-height="125px"
                 :arrows-outside="!arrowsOutside"
                 :arrows="true"
                 bullets-outside
                 :touchable="false"
                 :visible-slides="itemsPerSlide"
                 :gap="5"
                 disableArrowsOnEdges
                 :slide-ratio="0.5"
                 slideMultiple
                 :breakpoints="{ 800: { visibleSlides: 3, slideMultiple: 3 } }">

    <template v-slot:arrow-left>
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
    </template>

    <template v-slot:arrow-right>
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
    </template>

    <!--<vueper-slide class="selector__slide"-->
                  <!--:class="!selectedFabric ? 'selected' : ''"-->
                  <!--@click.native="resetFabric()"-->
                  <!--image="/img/modelli-none.jpg"></vueper-slide>-->
    <vueper-slide class="selector__slide" :class="selectedFabric && selectedFabric.name === item.name  ? 'selected' : ''" v-for="(item,i) in items" :key="item.name" :title="item.label" :image="item.material.bumpMap.src || item.material.alphaMap.src" @click.native="setFabric(item,i)" />
  </vueper-slides>
</template>

<script>
  // import * as THREE from 'three';
  import { VueperSlides, VueperSlide } from 'vueperslides'

  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import * as mutationTypes from '../../store/mutation-types'

  export default {
    name: "FabricCarousel",
    props: {
      items: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        itemsPerSlide: 3,
        vilibleSlide: 3,
        selectedDress: null,
      }
    },
    components: {
      VueperSlide,
      VueperSlides
    },
    computed: {
      ...mapGetters('fabrics',[
        'selectedFabric',
      ]),
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      arrowsOutside: function() {
        return this.items.length > this.vilibleSlide;
      },
    },
    watch: {
      selectedMesh: function() {
        if(this.selectedMesh.userData.fabric) {
          this[mutationTypes.APPLY_FABRIC](this.selectedMesh.userData.fabric);
          this.goToSlide(this.selectedMesh.userData.fabric);
        }
      }
    },
    methods: {
      ...mapActions('fabrics',[
        'applyFabric',
        'initFabric',
      ]),
      ...mapActions('textures',[
        'uploadTexture',
      ]),
      ...mapActions('clothes',[
        'disposeMesh',
      ]),
      ...mapActions([
        'render'
      ]),
      ...mapMutations('fabrics',[
        mutationTypes.APPLY_FABRIC,
      ]),
      async setFabric(fabric) {
        this.$Progress.start();
        await this.$store.dispatch('fabrics/applyFabric',{ payload: fabric});
        this.$Progress.finish();
      },
      goToSlide(fabric) {
        let i = this.items.indexOf(fabric);
        this.$refs.slider && this.$refs.slider.goToSlide(i);
      }
    },
    mounted() {
      // console.log(this.items);
      this.vilibleSlide = this.items.length > this.itemsPerSlide ? this.itemsPerSlide : this.items.length;
      // console.log(this.selectedMesh);
      if(this.selectedMesh && this.selectedMesh.userData.fabric) {
        this[mutationTypes.APPLY_FABRIC](this.selectedMesh.userData.fabric);
        setTimeout(this.goToSlide(this.selectedMesh.userData.fabric), 500);
        // this.goToSlide(this.selectedMesh.userData.fabric);
      }
    }
  }
</script>

<style scoped>

</style>